export default "__VITE_ASSET__DotyE$AO__"